import LoginForm from "../../components/Auth/LoginForm";

export default function SignIn() {
  return <LoginForm />;
}
